export const isIOS = (): boolean => !!navigator.userAgent.match(/ipad|iphone/i);
